import { enabledProviders, type OAuthProvider } from "@contract/auth/oauth";
import { env } from "../env";

/** The OAuth providers the panel offers (firm-model spec R24): the list, labels and rule
 * are shared with the add-in in `contract/auth/oauth.ts`; this module only asks Supabase. */
export { enabledProviders, PROVIDER_LABEL, type OAuthProvider } from "@contract/auth/oauth";

/** Asks Supabase which providers are on. A failure offers email only. */
export async function fetchEnabledProviders(fetchImpl: typeof fetch = fetch): Promise<OAuthProvider[]> {
  try {
    const res = await fetchImpl(`${env.supabaseUrl}/auth/v1/settings`, {
      headers: { apikey: env.supabaseAnonKey },
    });
    if (!res.ok) return [];
    return enabledProviders(await res.json());
  } catch {
    return [];
  }
}
